<template>
  <div class="formulate-input">
    <label v-if="label" class="formulate-input-label">{{ label }}</label>
    <UnitsSelectPaginated
      :value="selectedUnitId"
      :initial-options="selectedInitialOptions"
      :multiple="false"
      :placeholder="$t('custom_forms.select_facility')"
      :disabled="disabled"
      @input="onValueChanged"
    />
  </div>
</template>

<script>
import UnitsSelectPaginated from "@/components/UnitsSelectPaginated.vue";

export default {
  name: "UnitPickerInput",
  components: {
    UnitsSelectPaginated,
  },
  props: {
    value: {
      type: [Number, String, Object, null],
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    context: {
      type: Object,
      default: null,
    },
    onUpdateValue: {
      type: Function,
      default: null,
    },
  },
  computed: {
    selectedRawValue() {
      if (this.context && this.context.model !== undefined) return this.context.model;
      return this.value;
    },
    selectedUnitId() {
      return this.extractUnitId(this.selectedRawValue);
    },
    selectedInitialOptions() {
      const raw = this.selectedRawValue;
      if (!raw || typeof raw !== "object") return [];
      const id = this.extractUnitId(raw);
      if (id == null || raw.label == null) return [];
      return [{ value: id, label: String(raw.label) }];
    },
  },
  methods: {
    extractUnitId(value) {
      if (value == null) return null;
      if (typeof value === "object") {
        if (value.value != null) return value.value;
        if (value.id != null) return value.id;
        return null;
      }
      return value;
    },
    onValueChanged(nextValue) {
      if (this.onUpdateValue) {
        this.onUpdateValue(nextValue || null);
      }
      if (this.context) {
        this.context.model = nextValue || null;
      }
      this.$emit("input", nextValue || null);
    },
  },
};
</script>
